import { Component, ViewChild } from '@angular/core';
import { MatLegacyTableDataSource } from '@angular/material/legacy-table';
import { EnvService } from '../services/env.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { debounceTime } from 'rxjs';
import { OsFamilyFilter } from './os-family.filter';
import {MatLegacyPaginator as MatPaginator} from '@angular/material/legacy-paginator';
import { MatTableDataSource } from '@angular/material/table';
import { SettingsPersistenceService } from '../services/settings-persistence.service';
import { AuthService } from '../services/auth.service';

@Component({
  selector: 'app-osFamily',
  templateUrl: './os-family.component.html',
})
export class OsFamilyComponent {
  dataSource = new MatTableDataSource<any>();
  osTypeNames = new Map<string, string>();

  @ViewChild(MatPaginator, {static: true}) paginator!: MatPaginator;
  pageSettings!: SettingsPersistenceService;
  filter = new OsFamilyFilter(this.auth);


  constructor(public auth: AuthService, private env: EnvService, private http: HttpClient) {
  }

  ngOnInit(): void {
    // Setup the settings persistence service for this page
    this.pageSettings = new SettingsPersistenceService(sessionStorage, 'micro.osFamilies');
    this.pageSettings
      .setFilter(this.filter)
      .setPaginator(this.paginator)
      .init();

    // Subscribe to filter changes with a debounce time to avoid excessive reloads
    this.filter.anyChange.pipe(debounceTime(500)).subscribe(change => {
      this.reload();
    });

    // Initial data load
    this.reload();
  }

  ngOnDestroy(): void {
  }

  reload(): void {
    const params: HttpParams = this.filter.getParams()
      .set('page', String(this.paginator.pageIndex || 0))
      .set('size', String(this.paginator.pageSize || 20));

    this.http.get(`${this.env.e.url}/domain/cmdbOsFamily`, {params}).subscribe(data => {
      const page = data as any;
      this.dataSource.data = page.content;
      this.paginator.pageIndex = page.number;
      this.paginator.pageSize = page.size;
      this.paginator.length = page.totalElements;
      this.loadOSTypeNames(page.content || []);
    });
  }

  private loadOSTypeNames(osVersions: any[]): void {
    const osTypeIds = [...new Set(osVersions
      .map(osVersion => osVersion.osTypeId)
      .filter(tagId => tagId && !this.osTypeNames.has(tagId)))];

    osTypeIds.forEach(id => {
      this.http.get(`${this.env.e.url}/domain/cmdbOsType/${id}`).subscribe({
        next: (osType: any) => {
          this.osTypeNames.set(id, osType ? osType.name : '');
          this.dataSource.data = [...this.dataSource.data];
        },
        error: () => {
          this.osTypeNames.set(id, '');
          this.dataSource.data = [...this.dataSource.data];
        }
      });
    });
  }
  
}
